<div id="pageTopWrapper">
  <ng-container *ngIf="isDashboardForm; else ILTSessionList">
    <topaz-banner class="alertBanner" *ngIf=" status == 'ILT_OPEN' || status == 'REJECT' ||status == 'OPEN' || status === 'REINSTATE_SUBMIT'"
      [bannerType]=" status == 'REJECT' || status === 'REINSTATE_SUBMIT' ? 'alert':'success'" useIcon disableScrolling
      disableCloseButton>
      <div banner-content>
        <span class="topaz-banner-subcontent" *ngIf=" status == 'REJECT'">
          <b>Alert: Your application has been rejected</b><br />
          Thank you for your interest in becoming a Microsoft Certified Trainer. Unfortunately, we are unable to approve
          your application at this time.
          <br />
          This decision may be due to one or more eligibility requirements not being met. If additional detail or
          clarification is needed, please contact our support team at <a aria-label="Email MCT Support at mctpvsupport@pearson.com"
            href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a> for guidance on potential next
          steps.
          <br />
          We appreciate your interest in the Microsoft Certified Trainer program and encourage you to reapply in the
          future
          when the eligibility criteria are met.
        </span>
        <span class="topaz-banner-subcontent" *ngIf="status == 'ILT_OPEN'">
          We would like to inform you that your ILT training enrollment and payment remain incomplete.
          Kindly proceed again to complete the process.
          <br />
          For questions, please contact us at <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a>
          - we’re here to help!
        </span>
        <span class="topaz-banner-subcontent" *ngIf="status == 'OPEN'">
          Thank you for submitting your application to become a Microsoft Certified Trainer. 
          <br/>
          Your application is under review, and additional information regarding next steps will be provided via email within 3-5 business days.
            <br/>
          For questions, please contact us at <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a> - we’re here to help!
        </span>

        <span class="topaz-banner-subcontent" *ngIf="status=== 'REINSTATE_SUBMIT'">
          We’re reviewing your credentials and will notify you by email once your status is confirmed. You may close
          this
          window.
        </span>
      </div>
    </topaz-banner>

    <mat-card class="pagewrapper" *ngIf="show">
      <mat-card-title class="welcome-title">
        <h2>Welcome! Let’s create your account</h2>
      </mat-card-title>

      <mat-card-title class="first-details-text">
        <h2>First, tell us more about you. </h2>
      </mat-card-title>

      <ng-container>
        <app-iltform *ngIf="userSelectedFlow == 'ILTFlow'" [countryList]="countryList" [languageList]="languageList" [isFromRenewal]="isFromRenewal"
          (toggleILTSessionList)="toggleILTSessionList()"></app-iltform>
        <app-iscpforms *ngIf="userSelectedFlow == 'ISCPFlow'" [countryList]="countryList" [isFromRenewal]="isFromRenewal"
          [languageList]="languageList"></app-iscpforms>
      </ng-container>
    </mat-card>
    
  </ng-container>

  <ng-template #ILTSessionList>
    <div class="sessionListWrapper">
      <app-iltsession-list></app-iltsession-list>
    </div>
  </ng-template>

  <mat-card class="help-wrapper" *ngIf="show">
    <mat-card-title class="help-title">
      Need help?
    </mat-card-title>
  </mat-card>

  <mat-card class="help-req-wrapper" *ngIf="show">
    <mat-card-title class="help-req-title">
      <p>Send us a request</p>
    </mat-card-title>
    <mat-card-content class="help-req-content">
      If you have any questions or need assistance, our support team is here to help.<br />
      <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a>
    </mat-card-content>
  </mat-card>

</div>
